import React from 'react';
import ExportQueueItem from '../../../Domain/ExportQueueItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ExportQueueService from '../../../Services/ExportQueueService';
import ExportQueueSearchParams from './AllExport/ExportQueueSearchParams';

export default class ExportQueueAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      shownPanel: ExportQueueSearchParams.isThereAnySearchParameter() ? ShownPanelsEnum.Search : ShownPanelsEnum.None,
      searchItem: new ExportQueueSearchParams(),
    };
    this.refresh = this.refresh.bind(this);
    this.startSearch = this.startSearch.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={ExportQueueItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ExportQueueService.GetListBySearching}
          convertDBItemsFunction={ExportQueueService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={true}
          searchParamsType={ExportQueueSearchParams}
          clickOnStartSearch={this.startSearch}
          errorCode='EQA63'
        />
      </div>
    );
  }
}
